/* eslint-disable */
import clsx from 'clsx';

import {
  RACModal,
  RACButton,
  makeStyles,
  RACCOLOR,
  TextField,
  RACFieldError,
  RACSelect,
  RACTextbox,
  Grid,
  RACToggle,
} from '@rentacenter/racstrap';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next'; // Import i18next

import { Typography } from '@material-ui/core';
import React, { useContext,useEffect, useState } from 'react';
import { updatePhoneInstructions } from '../../../api/Customer';
import { useCustomerDetails } from '../../../context/CustomerDetails/CustomerDetailsProvider';
import { AppRoute } from '../../../config/route-config';
import { Link } from 'react-router-dom';
import {
  CustomerPhoneInstruction,
  PhoneType,
  ReferenceKeys,
  ReferenceOption,
  ReferenceResponse,
} from '../../../types/types';
import {
  API_ERROR_MESSAGE,
  CACHED_KEYS,
  INVALID_PHONE_NUMBER,
  INVALID_PHONE_NOTES,
  PHONE_INSTRUCTIONS_ERROR_MESSAGE,
  REQUIRED_FIELD_MESSAGE,
} from '../../../constants/constants';
import { getReference } from '../../../api/reference';
import { orderByDisplaySeqField } from '../../../context/PastDueListSearchCriteria/PastDueListSearchCriteriaProvider';
import { pipe, mapReferenceResponse } from '../../../utils/utils';
import { StoreStateContext, useStoreDetails } from '../../../context/Store/StoreProvider';

export interface ModalProps {
  open: boolean;
  onClose: (onclose: string) => void;
  onError?: (message: string) => void;
  onChange: (
    phoneId: string,
    notes: string,
    bestTimeToCall: string,
    phoneNumber: string,
    countryCodeCheck:string,
    phoneType: string,
    ext: string
  ) => void;
  phoneId: string;
  note: string | null;
  phoneNumber?: string;
  countryCodeCheck?: string;
  phoneType?: string;
  ext?: string;
  bestTimeToCall?: string;
  active?: string;
  primary?: string;
  // notice that "Notes" are always editable
  isPhoneNumberEditable?: boolean;
  isExtEditable?: boolean;
  isBestTimeToCallEditable?: boolean;
}
export const useStyles = makeStyles((theme: any) => ({
  dialogContent: {
    textAlign: 'left',
    height: theme.typography.pxToRem(600),
  },
  dialogRoot: {
    '& .MuiDialogContent-root': {
      padding: '20px 10px 0px 20px',
    },
    '& .MuiDialog-paperWidthSm': {
      maxWidth: theme.typography.pxToRem(550),
      maxHeight: theme.typography.pxToRem(600),
      marginTop: theme.typography.pxToRem(400),
    },
    '& .MuiTypography-h4': {
      fontSize: '20px !important',
    },
    '& .MuiOutlinedInput-multiline': {
      padding: theme.typography.pxToRem(5),
      maxHeight: theme.typography.pxToRem(160),
      height: theme.typography.pxToRem(160),
    },
    '& .MuiInputBase-multiline': {
      margin: '8px 0px 0px 0px !important',
    },
    '& .MuiInputBase-input': {
      fontFamily: 'OpenSans-regular',
      fontSize: theme.typography.pxToRem(14),
    },

    height: theme.typography.pxToRem(470),
  },
  dialogTitle: {
    fontFamily: 'OpenSans-bold',
    fontSize: '20px !important',
    color: '#212529',
  },
  label: {
    fontFamily: 'OpenSans-regular',
    fontSize: theme.typography.pxToRem(14),
    color: '#212529',
    padding: '0px 0px 8px',
    fontWeight: 'bold',
  },
  dialogActions: {
    paddingRight: theme.typography.pxToRem(15),
    paddingBottom: theme.typography.pxToRem(15),
  },
  textfield: {
    width: '100%',
    color: RACCOLOR.ONYX,
  },
  button: {
    height: theme.typography.pxToRem(47),
    width: theme.typography.pxToRem(96),
    paddingTop: theme.typography.pxToRem(12),
    paddingRight: theme.typography.pxToRem(25),
    paddingBottom: theme.typography.pxToRem(12),
    paddingLeft: theme.typography.pxToRem(25),
    marginRight: theme.typography.pxToRem(9),
    backgroundColor: '#FAFCFF !important',
    borderColor: '#CEE0FF !important',
    border: '1px solid !important',
    color: '#5a5a5a !important',
    '&:hover': {
      color: '#FFF !important',
      borderColor: '#565e64 !important',
      backgroundColor: '#5c636a !important',
    },
  },
  smallbutton: {
    height: theme.typography.pxToRem(43),
    width: theme.typography.pxToRem(77),
  },
  row: {
    display: 'inline-flex',
    width: '100%',
    marginBottom: theme.typography.pxToRem(5),
  },
  leftField: {
    width: '50%',
    marginLeft: theme.typography.pxToRem(5),
  },
  rightField: {
    width: '50%',
    marginRight: theme.typography.pxToRem(5),
  },
  leftSecondField: {
    width: '25%',
    marginLeft: theme.typography.pxToRem(5),
  },
  leftThirdField: {
    width: '25%',
    marginLeft: theme.typography.pxToRem(35),
  },
  textBold: {
    fontSize: theme.typography.pxToRem(16),
  },
  textCenter: {
    textAlign: 'center',
  },
  notesErrorMessage: {
    color: RACCOLOR.MVS_RED,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 400,
    lineHeight: theme.typography.pxToRem(19.5),
    margin: 0,
  },
  notVisible: {
    display: 'none',
    visibility: 'hidden',
  },
  errormess: {
    marginTop: theme.typography.pxToRem(16),
    marginBottom: theme.typography.pxToRem(16),
    fontFamily: 'OpenSans-bold',
    fontSize: theme.typography.pxToRem(16),
    color: RACCOLOR.MVS_RED,
    letterSpacing: 0,
    visibility: 'visible',
  },
}));

export const getFormatedPhone = (phone: string) => {
  const cleaned = phone.replace(/\D/g, '');
  const PhoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return cleaned.replace(PhoneRegex, '($1) $2-$3');
};

export const getLabelFromValue = (options: ReferenceOption[], value: string) =>
  options.find((option) => option.value === value)?.label || '';

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  // Extract digits from formatted phone numbers
  const digitsOnly = phoneNumber.replace(/\D/g, '');
  
  // Check if exactly 10 digits
  if (digitsOnly.length !== 10) {
    return false;
  }
  
  // Validate against pattern: no repeated digits, no sequential patterns
  const phonePattern = /^(?!(\d)\1{9})(?!0123456789|1234567890|9876543210|0987654321)\d{10}$/;
  return phonePattern.test(digitsOnly);
};

export const EditContactInformationModal = ({
  open,
  phoneId,
  note,
  phoneNumber,
  countryCodeCheck,
  ext,
  phoneType,
  bestTimeToCall,
  active,
  primary,
  onChange,
  onClose,
  onError,
}: ModalProps) => {
  const classes = useStyles();
  const {
    customerDetails: { customerId, globalCustomerId, phones, coCustomerId },
    countryCode,
    coCustomerDetails: {
      phones: coCustomerPhones,
      globalCustomerId: coCustomerGlobalCustomerId,
    } = {},
  } = useCustomerDetails();
  const {enableCountryCode} = useContext(StoreStateContext);
  const [tempNotes, setTempNotes] = useState(note || '');
  const [tempPhoneNumber, setTempPhoneNumber] = useState(
    getFormatedPhone(phoneNumber || '')
  );
  const { t } = useTranslation();
  const { store } = useStoreDetails();
  const countryAbb = store?.countryAbb?.toUpperCase();
  const regionCode = countryCode.filter((item)=> item.abbreviation == countryAbb)
  const [tempCountryCode, settempCountryCode] = useState(countryCodeCheck);
  const [tempExt, setTempExt] = useState(ext || '');
  const [tempPhoneType, setTempPhoneType] = useState(phoneType || '');
  const [tempBestTimeToCall, setTempBestTimeToCall] = useState(
    bestTimeToCall || ''
  );
  const [loading, setLoading] = useState(false);

  const [loadingOptions, setLoadingOptions] = useState(false);
  const [loadingOptionsApiError, setLoadingOptionsApiError] = useState(false);
  const [bestTimeToCallOptions, setBestTimeToCallOptions] = useState<
    ReferenceOption[]
  >([]);

  const [phoneTypes, setPhoneTypes] = useState<ReferenceOption[]>([]);
  const [phoneNumberErrorMessage, setPhoneNumberErrorMessage] = useState('');
  const [phoneNotesErrorMessage, setPhoneNotesErrorMessage] = useState('');

  const [inActiveProblem, setInActiveProblem] = useState(false);
  const [check, setCheck] = useState(false);
  const [tempActive, setTempActive] = useState(active || '');
  const [isFormValid, setIsFormValid] = useState(false);

  const handleActiveChange = (e: any) => {
    if (e.target.checked) {
      setTempActive('Y');
      setInActiveProblem(false);
    } else {
      if (primary == 'Y') {
        setInActiveProblem(true);
      }
      setTempActive('N');
    }

    setCheck(!check);
  };

  const validateForm = (): boolean => {
    let valid = true;

    // Reset error messages
    setPhoneNumberErrorMessage('');
    setPhoneNotesErrorMessage('');
    setInActiveProblem(false);

    // Check if trying to deactivate primary phone
    if (tempActive !== 'Y' && primary === 'Y') {
      setInActiveProblem(true);
      valid = false;
    }

    // Validate notes length
    if (tempNotes && tempNotes.length > 50) {
      setPhoneNotesErrorMessage(i18n.t(INVALID_PHONE_NOTES));
      valid = false;
    }

    // Validate phone number presence
    if (!tempPhoneNumber.trim()) {
      setPhoneNumberErrorMessage(i18n.t(REQUIRED_FIELD_MESSAGE));
      valid = false;
    } else if (tempPhoneNumber.trim().length < 10) {
      setPhoneNumberErrorMessage(i18n.t(INVALID_PHONE_NUMBER));
      valid = false;
    } else if (!isValidPhoneNumber(tempPhoneNumber)) {
      setPhoneNumberErrorMessage(i18n.t(INVALID_PHONE_NUMBER));
      valid = false;
    }

    // Validate required fields
    if (!tempPhoneType) {
      valid = false;
    }

    if (!tempBestTimeToCall) {
      valid = false;
    }

    return valid;
  };

  // Reactive validation with useEffect
  useEffect(() => {
    if (open) {
      const isValid = validateForm();
      setIsFormValid(isValid);
    }
  }, [
    tempPhoneNumber,
    tempNotes,
    tempPhoneType,
    tempBestTimeToCall,
    tempActive,
    open,
  ]);

  const handleClose = () => {
    if (tempActive != 'Y') {
      phones?.filter((phone, index) => {
        if (phone.phoneId === phoneId) {
          phones.splice(index, 1);
        }
      });
    }
    onChange(
      tempCountryCode,
      phoneId,
      tempNotes,
      getLabelFromValue(bestTimeToCallOptions, tempBestTimeToCall),
      tempPhoneNumber,
      getLabelFromValue(phoneTypes, tempPhoneType),
      tempExt
    );
    onClose(phoneId);
  };

  const clearFields = () => {
    setTempNotes('');
    setTempPhoneType('');
    setTempBestTimeToCall('');
    setTempExt('');
    setTempPhoneNumber('');
    setTempActive('');
    setPhoneNotesErrorMessage('');
    setInActiveProblem(false);
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const handleSave = () => {
    // Validate form before saving
    if (!validateForm()) {
      return;
    }

    const selectedCustomerPhone = phones?.find(
      (phone) => phone.phoneId === phoneId
    ) as CustomerPhoneInstruction;

    const selectedCoCustomerPhones = coCustomerPhones?.find(
      (phone) => phone.phoneId === phoneId
    ) as CustomerPhoneInstruction;

    if (
      (!selectedCustomerPhone && !selectedCoCustomerPhones) ||
      (selectedCustomerPhone && (!customerId || !globalCustomerId)) ||
      (selectedCoCustomerPhones &&
        (!coCustomerId || !coCustomerGlobalCustomerId))
    )
      return;

    const selectedPhone = selectedCustomerPhone
      ? selectedCustomerPhone
      : selectedCoCustomerPhones;

    selectedPhone.note = tempNotes;
    selectedPhone.callTimeType = tempBestTimeToCall;
    selectedPhone.phoneNumber = tempPhoneNumber;
    selectedPhone.active = tempActive;
    selectedPhone.phoneType = tempPhoneType as PhoneType;
    selectedPhone.extension = tempExt;
    selectedPhone.countryCode = enableCountryCode ? tempCountryCode : undefined;
    const payload = selectedCustomerPhone
      ? {
          customerId: customerId || '',
          globalCustomerId: globalCustomerId || '',
          phones: [selectedPhone],
        }
      : {
          customerId: coCustomerId || '',
          globalCustomerId: coCustomerGlobalCustomerId || '',
          phones: [selectedPhone],
        };

    setLoading(true);
    updatePhoneInstructions(payload)
      .then(handleClose)
      .catch(() => onError && onError(i18n.t(PHONE_INSTRUCTIONS_ERROR_MESSAGE)))
      .finally(() => {
        setLoading(false);
        setPhoneNotesErrorMessage('');
      });
  };

  useEffect(() => {
    setLoadingOptionsApiError(false);
    setLoadingOptions(true);
    getReference(
      [ReferenceKeys.PHONE_TYPE, ReferenceKeys.BEST_TIME_TO_CALL],
      CACHED_KEYS.EDIT_CUSTOMER_INFORMATION_KEY
    )
      .then((response: any) => {
        const { references } = response;
        references?.map((reference: ReferenceResponse) => {
          if (reference.referenceKey === ReferenceKeys.BEST_TIME_TO_CALL) {
            return pipe(
              orderByDisplaySeqField,
              mapReferenceResponse,
              setBestTimeToCallOptions
            )(reference?.referenceDetails);
          } else if (reference.referenceKey === ReferenceKeys.PHONE_TYPE) {
            return pipe(
              orderByDisplaySeqField,
              mapReferenceResponse,
              setPhoneTypes
            )(reference?.referenceDetails);
          }
        });
      })
      .catch(() => {
        setLoadingOptionsApiError(true);
      })
      .finally(() => {
        setLoadingOptions(false);
      });
  }, []);

  useEffect(() => {
    setTempNotes(note || '');
    setTempExt(ext || '');
    setTempBestTimeToCall(bestTimeToCall || '');
    setTempPhoneType(phoneType || '');
    setTempPhoneNumber(getFormatedPhone(phoneNumber || ''));
    setTempActive(active || '');
    setCheck(active == 'Y' ? true : false);
    settempCountryCode(countryCodeCheck || '');
  }, [bestTimeToCall, ext, note, open, phoneNumber, phoneType, active, countryCodeCheck]);

  const primaryCheck = primary == 'Y' ? true : false;

  const closeModal = () => {
    clearFields();
    onClose(phoneId);
  };

  const handlePhoneNumberChange = (e: any) => {
    const formattedPhone = getFormatedPhone(e.target.value);
    setTempPhoneNumber(formattedPhone);
  };
  const translatedbestTimeToCallOptions = bestTimeToCallOptions.map(
    (option) => ({
      ...option,
      label: t(option.label),
    })
  );
  const translatedphoneTypes = phoneTypes.map((option) => ({
    ...option,
    label: t(option.label),
  }));
  return (
    <RACModal
      isOpen={open}
      titleVariant="h4"
      classes={{
        dialogTitle: classes.dialogTitle,
        dialogContent: classes.dialogContent,
        dialog: classes.dialogRoot,
        dialogActions: classes.dialogActions,
      }}
      maxWidth="sm"
      title={t('Contact Information')}
      content={
        <>
          <div className={classes.row}>
            <div className={classes.rightField}>
              <div style={{width:'100%',display:'flex'}}>
                {enableCountryCode == 1 && (<div style={{width: '25%', marginTop: 'auto'}}>
                {enableCountryCode==1?(<RACSelect
                options={countryCode.map((item=> ({label : `+${item.countryCodeValue}` , value : item.countryCodeValue})))}
                loading={loadingOptions}
                defaultValue={tempCountryCode? tempCountryCode: null}
                onChange={(e: React.ChangeEvent<{ value: any }>) =>
                  settempCountryCode(e.target.value)
                }
                isDisabled={loading}
              />):(<div></div>)}
              </div>)}
              <div style={{ width:enableCountryCode == 1 ? '80%' : '100%'}}>
              <RACTextbox
                name="phoneNumber"
                type="phoneno"           
                inputlabel={t('Phone Number')}
                maxlength={10}
                value={tempPhoneNumber}
                disabled={loading}
                required
                OnChange={handlePhoneNumberChange}
              />
              </div>
              </div>
              {phoneNumberErrorMessage && (
                <RACFieldError
                  className={classes.notesErrorMessage}
                  errorMessage={phoneNumberErrorMessage}
                />
              )}
            </div>
            <div className={classes.leftField}>
              <RACTextbox
                name="ext"
                inputlabel={t('Ext')}
                value={tempExt}
                disabled={loading}
                type="number"
                maxlength={5}
                OnChange={(e: React.ChangeEvent<{ value: any }>) =>
                  setTempExt(e.target.value)
                }
              />
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.rightField}>
              <RACSelect
                inputLabel={t('Phone Type')}
                options={translatedphoneTypes}
                loading={loadingOptions}
                defaultValue={tempPhoneType}
                onChange={(e: React.ChangeEvent<{ value: any }>) =>
                  setTempPhoneType(e.target.value)
                }
                {...(loadingOptionsApiError && {
                  errorMessage: t(API_ERROR_MESSAGE),
                })}
                required
                isDisabled={loading}
              />
            </div>
            <div className={classes.leftField}>
              <RACSelect
                inputLabel={t('Best Time to Call')}
                options={translatedbestTimeToCallOptions}
                loading={loadingOptions}
                defaultValue={tempBestTimeToCall}
                onChange={(e: React.ChangeEvent<{ value: any }>) =>
                  setTempBestTimeToCall(e.target.value)
                }
                required
                {...(loadingOptionsApiError && {
                  errorMessage: t(API_ERROR_MESSAGE),
                })}
                isDisabled={loading}
              />
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.rightField}>
              <Typography component="label" className="label floatLeft mt-2">
                {t('Is Primary?')}
              </Typography>

              <RACToggle
                style={{ marginLeft: 0 }}
                checked={primaryCheck}
                disabled
                toggleColor="#A5C8FD"
                name="togglePrimarytoggle"
                id="togglePrimary"
              />
            </div>
            <div className={classes.leftField}>
              <Typography component="label" className="label floatLeft mt-2">
                {t('Is Active?')}
              </Typography>

              <RACToggle
                style={{ marginLeft: 0 }}
                checked={check}
                toggleColor="#0d6efd"
                name="toggleActivetoggle"
                id="toggleActive"
                OnChange={(e: any) => {
                  handleActiveChange(e);
                }}
              />
            </div>
          </div>
          <div
            className={
              inActiveProblem ? clsx(classes.row) : clsx(classes.notVisible)
            }
          >
            <Grid item md={12} className={classes.textBold}>
              {
                <Typography
                  variant="body2"
                  className={
                    inActiveProblem
                      ? clsx(classes.errormess)
                      : clsx(classes.notVisible)
                  }
                >
                  {t(
                    'You cannot disable a primary phone number. Please add a primary number before disabling it.'
                  )}
                  <Link
                    style={{
                      textDecoration: 'unset',
                    }}
                    to={{
                      pathname: `${AppRoute.CustomerUpdate}/${customerId}/customer`,
                    }}
                  >
                    {'  '}
                    {t('Click here')}
                    {'  '}
                  </Link>
                  {t(
                    'to update the change in the contact information of the customer.'
                  )}
                </Typography>
              }
            </Grid>
          </div>
          <div>
            <label className={clsx(classes.label)}>{t('Notes')}</label>
            <TextField
              multiline
              onFocus={(event) =>
                event.currentTarget.setSelectionRange(
                  tempNotes.length,
                  tempNotes.length
                )
              }
              variant="outlined"
              value={tempNotes}
              key={phoneId}
              maxRows={8}
              minRows={8}
              className={clsx(classes.textfield)}
              onChange={(e) => {
                setTempNotes(e.target.value);
              }}
              disabled={loading}
            />
            {phoneNotesErrorMessage && (
              <RACFieldError
                className={classes.notesErrorMessage}
                errorMessage={phoneNotesErrorMessage}
              />
            )}
          </div>
        </>
      }
      onClose={closeModal}
      buttons={
        <>
          <RACButton
            variant="outlined"
            color="secondary"
            className={clsx(classes.button)}
            onClick={closeModal}
            disabled={loading}
          >
            {t('Cancel')}
          </RACButton>
          <RACButton
            variant="contained"
            color="primary"
            className={clsx(classes.smallbutton)}
            onClick={handleSave}
            disabled={loading || !isFormValid}
          >
            {t('Save')}
          </RACButton>
        </>
      }
    />
  );
};
